import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Grid,
  GridProps,
} from '@mui/material';
import { FORM_STYLES } from '../../../constants';

interface FormikCheckboxProps {
  name: string;
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  gridProps?: GridProps;
}

const FormikCheckbox: React.FC<FormikCheckboxProps> = ({
  name,
  label,
  checked,
  onChange,
  onBlur,
  error,
  disabled = false,
  required = false,
  gridProps = { xs: 12 },
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl fullWidth error={!!error} className="radio-group question-group">
        <FormLabel>
          <FormControlLabel
            className="checkbox-shoartage"
            control={
              <Checkbox
                disableRipple
                name={name}
                checked={checked}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
              />
            }
            label=""
          />
          <span style={FORM_STYLES.INPUT}>
            {label} {required && <sup>*</sup>}
          </span>
        </FormLabel>
        {error && <FormHelperText sx={{ marginLeft: '0px !important' }}>{error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default FormikCheckbox;